import React from 'react';

import { DateRangePicker } from '@gogame/components';
import { Filter, FilterActions, set } from '@gogame/filters';
import { isGoGameEnv } from 'App/constants';
import { getPayToByPeriod, getPayToForCompare } from './utils';
import { PERIOD_PRESETS } from './presets';

const PeriodFilter = ({
  'data-cy': dataCy,
  payToLocked,
  getMultipleValue,
  name,
  payToName,
  onCompare,
  presets = PERIOD_PRESETS,
  withPayTo,
  ...props
}) => {
  return (
    <Filter
      {...props}
      title={'Registration period'}
      name={name}
      primaryFilterWidth={240}
      withClear={false}
      compareActions={[
        <FilterActions.CompareToPreviousPeriod
          onSetValues={({ getPathByName, values, value }) => {
            return set(values, {
              [getPathByName(name)]: value,
              [getPathByName(payToName)]: getPayToForCompare(value),
            });
          }}
        />,
        <FilterActions.Equalize />,
      ]}
      renderComponent={({
        label,
        value,
        actions,
        onChange,
        onChangeMultiple,
        compared,
      }) => (
        <DateRangePicker
          data-cy={name}
          label={label}
          value={value}
          onChange={(e, value) => {
            if (withPayTo) {
              onChangeMultiple(e, {
                [name]: value,
                [payToName]: compared
                  ? getPayToForCompare(value)
                  : getPayToByPeriod(value),
              });
            } else {
              onChange(e, value);
            }
          }}
          {...(isGoGameEnv ? null : { maxRange: 24, unit: 'month' })}
          actions={actions}
          presets={presets}
          placeholder={''}
          disableFuture={true}
          checkPresetValue={true}
          padding={0}
        />
      )}
    />
  );
};

export default PeriodFilter;
